<template>
	<div class="cnt-mapeamento">
		<template v-if="dataIn">
			<div class="row">
				<div class="col-sm-5">
					<!-- dataIn.imagens -->
					<manipulacao-de-imagens :imagens="imagensFake" />
				</div>
				<div class="col-sm-7">
					<dimencionamento :funcoes="dataIn.funcoes" />
					<!-- <equipamentos /> -->
				</div>
			</div>
		</template>
		<template v-else>
			<div class="cnt-msg-new-setor">
				<h3>Esta empresa não tem informações para esse setor!</h3>
				<span>Deseja cadastrar dados para o setor?</span><br /><br />
				<button @click="$emit('iniciarSetor')" class="btn btn-primary">
					Cadastrar
				</button>
			</div>
		</template>
	</div>
</template>
<script>
	import ManipulacaoDeImagens from './components/ManipulacaoDeImagens.vue';
	import Equipamentos from './components/Equipamentos.vue';
	import Dimencionamento from './components/Dimencionamento.vue';

	export default {
		props: ['dataIn'],
		data() {
			return {
				imagensFake: [
					{
						title: 'Área de atendimento em piso cerâmico,  balcão e prateleiras em vidros, 4 computadores, 1 impressora térmica, 1 gaveta de dinheiro, máquinas de cartão, celular para atendimento ao público, 2 telefones fixos, teto em pvc.',
						url: '489042e3636984488c34d0e05c3f9d75.jpg',
					},
					{
						title: 'Circulação do cliente em piso cerâmico,  teto em pvc, ventiladores, prateleiras em vidro.',
						url: '7f86b827c7b75fec6681fe00e9b49a0c.jpg',
					},
					{
						title: 'Circulação do cliente em piso cerâmico, teto em pvc, prateleiras em vidro, ventiladores de teto. ',
						url: '1ac39ccd3cd514f722f6ecab87d6998b.jpg',
					},
					{
						title: 'Área de atendimento em piso cerâmico, teto em pvc, 4 computadores, 1 impressora térmica, máquinas de cartão, banco de madeira, máquina de recarga de celular, balcão e prateleiras  em vidro, ',
						url: '76dd3918e29fd3fc33eb2169f0f78793.jpg',
					},
				],
			};
		},
		components: {
			ManipulacaoDeImagens,
			Equipamentos,
			Dimencionamento,
		},
	};
</script>
<style scoped>
	.cnt-mapeamento {
		border: 1px solid #e3e3e3;
		background-color: #f5f5f5;
		border-bottom-right-radius: 3px;
		border-bottom-left-radius: 3px;
		padding: 10px;
	}
	.cnt-msg-new-setor {
		padding: 50px 65px 75px;
	}
</style>



// WEBPACK FOOTER //
// src/components/sst/seguranca/components/dimencionamento/components/itemSetor/index.vue